import React from "react";
import { useSelector } from "react-redux";
import styles from "./portal_buttons.module.css";
import { getPortal } from "../../services/selectors";


const PortalButtons = () => {

  const { title, buttons } = useSelector(getPortal);

  return (
    <>
      <h2 className={styles.title}>
        {title}
      </h2>
      {buttons.map((item, index) => {
        return (
          <div key={index} className={styles.buttonContainer}>
            <button
              className="button"
              onClick={item.func}
            >
              {item.name}
            </button>
            <p className={styles.text}>{item.text}</p>
          </div>
        );
      })}
    </>
  )
}

export default PortalButtons;
